// This icon file is generated automatically.
var DrrpLayoutIconOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M857 137H167c-16.6 0-30 13.4-30 30v690c0 16.6 13.4 30 30 30h690c16.6 0 30-13.4 30-30V167c0-16.6-13.4-30-30-30zm-652.5 67.5H332v615H204.5v-615zm615 615H392V392h427.5v427.5zM392 332V204.5h427.5V332H392z" } }] }, "name": "drrp-layout-icon", "theme": "outlined" };
export default DrrpLayoutIconOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/DrrpLayoutIconOutlined.js
// module id = 2573
// module chunks = 0